export default {"src":"/_next/static/media/Time.63bb1d28.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};